import { EditorState, RichUtils } from 'draft-js';
import { getEntityConsecutiveSelection } from './getEntityConsecutiveSelection';

export function toggleLink({ getEditorState, setEditorState, url }) {
	/** @type {EditorState} */
	const editorState = getEditorState();
	const contentState = editorState.getCurrentContent();

	let selection = editorState.getSelection();
	if (selection.isCollapsed()) {
		selection = getEntityConsecutiveSelection(editorState);
	}

	if (url) {
		const contentStateWithEntity = contentState.createEntity(
			'LINK',
			'MUTABLE',
			{ url }
		);
		const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
		const newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
		setEditorState(
			EditorState.forceSelection(
				RichUtils.toggleLink(
					newEditorState,
					selection,
					entityKey,
				),
				selection,
			)
		);
	} else {
		let selection = editorState.getSelection();
		if (selection.isCollapsed()) {
			selection = getEntityConsecutiveSelection(editorState);
		}
		setEditorState(
			EditorState.forceSelection(
				RichUtils.toggleLink(editorState, selection, null),
				selection
			)
		);
	}
}



// WEBPACK FOOTER //
// ./lib/helpers/toggleLink.js